import React from "react";
import { NumericFormat } from "react-number-format";
import { useGridApiContext } from "@mui/x-data-grid";
import { TextField, styled } from "@mui/material";
import { isNull } from "lodash";

const StyledTextField = styled(TextField)(({ theme, error }) => ({
  "& .MuiInput-root": {
    backgroundColor: theme.palette.primary.light,
    borderRadius: "4px",
  },
  "& .MuiInput-root.Mui-focused": {
    border: `1.5px solid ${theme.palette.tertiary.main} !important`,
    borderRadius: ".3rem",
  },
  "& .MuiInputBase-input": {
    border: `2px solid black`,
    textAlign: "right",
    padding: "4px 8px !important",
  },
}));

const InputEditTableCurrency = ({
  value,
  field,
  id,
  disabled = false,
  className,
  required,
  params,
  style,
  decimalScale = 0,
  maxLimit = 1000000000,
  onChange = null,
  autoFocus = false,
  decimalSeparator,
  tabIndex = -1,
}) => {
  const apiRef = useGridApiContext();

  const handleInputChange = event => {
    const newValue = event.value;
    apiRef.current.setEditCellValue({ id, field, value: newValue });
    if (!isNull(onChange)) {
      onChange(event);
    }
  };

  return (
    <div style={{ margin: "0 5px", display: "grid", width: "100%" }}>
      <NumericFormat
        value={value === 0 ? "" : value}
        disabled={disabled}
        className={className}
        thousandSeparator=","
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
        fixedDecimalScale
        customInput={StyledTextField}
        autoFocus
        inputProps={{ tabIndex }}
        onValueChange={handleInputChange}
        required={required}
        allowNegative={false}
        allowLeadingZeros={false}
        style={{ ...style, tabIndex: tabIndex }}
        isAllowed={values => {
          const { floatValue } = values;
          return floatValue < maxLimit || !floatValue;
        }}
        {...params}
      />
    </div>
  );
};
export default InputEditTableCurrency;
